<template>
  <template v-if="isError">
    <router-view />
  </template>
  <div v-else class="flex-container">
    <header class="pageheader">マイページ</header>
    <div class="nav-container">
      <div v-if="!hiddenSidebar" class="bg"></div>
      <div v-if="!hiddenSidebar" class="menu-button" tabindex="0">
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </div>
      <div class="nav-logo"><img src="images/logo.png" /></div>
      <div v-if="!hiddenSidebar" class="nav-content custom-restricted-width" tabindex="0">
        <div class="user-info"><span class="material-icons">account_circle</span>{{ store.state.me?.userName ?? "" }}さん</div>
        <hr />
        <aside class="menu">
          <ul class="menu-list">
            <li v-if="!store.state.me?.needPasswordChange">
              <router-link :to="{ name: 'Top' }"><span class="material-icons">home</span>Home</router-link>
            </li>
            <li v-if="!store.state.me?.needPasswordChange">
              <router-link :to="{ name: 'Top' }"><span class="material-icons">format_list_bulleted</span>契約一覧</router-link>
            </li>
            <li>
              <router-link :to="{ name: 'Password' }"><span class="material-icons">lock</span>パスワード変更</router-link>
            </li>
            <li>
              <router-link :to="{ name: 'Inquiry' }"><span class="material-icons">person_outline</span>お問い合わせ</router-link>
            </li>
          </ul>
          <hr />
          <ul class="menu-list">
            <li>
              <a @click="logout"><span class="material-icons">logout</span>ログアウト</a>
            </li>
          </ul>
        </aside>

        <div class="menu-item-credit">SANKO少額短期保険</div>
      </div>
    </div>
    <LoadingIndicator />
    <router-view v-slot="{ Component }">
      <transition name="router-transition">
        <component :is="Component" />
      </transition>
    </router-view>
    <footer class="pagefooter">
      <small>Copyright &copy; 2008- 株式会社 SANKO少額短期保険</small>
    </footer>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import router from "./router";
import { useStore } from "./store";
import { unauthorized } from "common/src/utils/request";
import LoadingIndicator from "common/src/components/LoadingIndicator.vue";

export default defineComponent({
  components: {
    LoadingIndicator,
  },
  setup() {
    const hiddenSidebar = computed(() => !!router.currentRoute.value.meta.anonymous);
    const isError = computed(() => !!router.currentRoute.value.meta.errorPage);

    const store = useStore();

    const logout = () => {
      unauthorized();
      router.push({ name: "Login" });
    };

    return {
      hiddenSidebar,
      isError,
      store,
      logout,
    };
  },
});
</script>

<style>
@import "https://cdn.jsdelivr.net/npm/bulma@0.9.3/css/bulma.min.css";
@import "https://fonts.googleapis.com/icon?family=Material+Icons";

body {
  background-color: #fff;
  color: #3c4858;
}

/* 画面遷移時のエフェクト */
.router-transition-enter-active {
  animation: fadeIn 1s;
  opacity: 0;
}

@keyframes fadeIn {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Color Palette */

.dark-primary-color {
  color: #d32f2f;
}
.light-primary-color {
  color: #ffcdd2;
}
.primary-color {
  color: #f44336;
}
.accent-color {
  color: #4caf50;
}
.divider-color {
  color: #bdbdbd;
}
.primary-text {
  color: #212121;
}
.secondary-text {
  color: #757575;
}

.accent-color-bg {
  background-color: #4caf50;
  color: #fff;
}

.primary-color-bg {
  background-color: #f44336;
  color: #fff;
}

.light-primary-color-bg {
  background-color: #ffcdd2;
  color: #212121;
}

.primary-color-bg > .card-header-title {
  color: #fff;
}

.card-header.page-title {
  background-color: #f44336;
}
.card-header.page-title .card-header-title {
  color: #fff;
}

.card-header-title.header-center {
  justify-content: center;
}

/* ベースカラー */
.base-color {
  color: #da8246;
}
/* アソートカラー */
.assorted-color {
  color: #f9e9cd;
}

.material-icons {
  display: inline-flex;
  vertical-align: middle;
  margin-right: 5px;
}

/*———————————
ラジオボタン
———————————*/
/*type-2*/
input[type="radio"].radio-type-2 {
  display: none;
}
input[type="radio"].radio-type-2 + label {
  position: relative;
  padding-left: 25px;
}
input[type="radio"].radio-type-2 + label::before {
  content: "";
  display: block;
  box-sizing: border-box;
  position: absolute;
  top: 2px;
  left: 0px;
  width: 20px;
  height: 20px;
  border: 2px solid #757575; /* SECONDARY TEXT */
  border-radius: 50%;
  transition: 0.2s;
}
input[type="radio"]:checked.radio-type-2 + label::before {
  border: 2px solid #4caf50; /* ACCENT COLOR */
}
input[type="radio"].radio-type-2 + label::after {
  content: "";
  display: block;
  box-sizing: border-box;
  position: absolute;
  top: 7px;
  left: 5px;
  width: 10px;
  height: 10px;
  background-color: #4caf50; /* ACCENT COLOR */
  border-radius: 50%;
  transform: scale(0);
  transition: 0.25s;
}
input[type="radio"]:checked.radio-type-2 + label::after {
  transform: scale(1);
}

/*———————————
チェックボックス
———————————*/
input[type="checkbox"].check-type-1,
input[type="checkbox"].check-type-2 {
  display: none;
}
input[type="checkbox"].check-type-1 + label,
input[type="checkbox"].check-type-2 + header label {
  position: relative;
  padding-left: 20px;
}
input[type="checkbox"].check-type-1 + label::before,
input[type="checkbox"].check-type-2 + header label::before {
  content: "";
  display: block;
  box-sizing: border-box;
  position: absolute;
  top: 4px;
  left: 2px;
  width: 16px;
  height: 16px;
  border: 2px solid #bdbdbd; /* DIVIDER COLOR */
  border-radius: 2px;
  transition: 0.2s;
  background-color: #ffffff;
}
input[type="checkbox"]:disabled.check-type-1 + label::before,
input[type="radio"]:disabled.check-type-1 + label::before {
  background-color: #bdbdbd;
}
input[type="checkbox"]:checked.check-type-1 + label::before,
input[type="checkbox"]:checked.check-type-2 + header label::before {
  border: 8px solid #4caf50; /* ACCENT COLOR */
}
/* チェックマーク */
input[type="checkbox"].check-type-1 + label::after,
input[type="checkbox"].check-type-2 + header label::after {
  content: "";
  display: block;
  box-sizing: border-box;
  position: absolute;
  top: 11px;
  left: 3px;
  width: 0;
  height: 0;
  transform: rotate(-45deg);
  transform-origin: left top;
  border-left: 2px solid #ffffff; /* TEXT/ICONS */
  border-bottom: 2px solid #ffffff; /* TEXT/ICONS */
  visibility: hidden;
}
input[type="checkbox"]:checked.check-type-1 + label::after,
input[type="checkbox"]:checked.check-type-2 + header label::after {
  animation: check 0.175s ease 0.2s 1 normal forwards;
}

/* サイズ指定 */
input[type="checkbox"].check-type-1.is-cb-medium + label,
input[type="checkbox"].check-type-2.is-cb-medium + header label {
  padding-left: 24px;
}
input[type="checkbox"].check-type-1.is-cb-medium + label::before,
input[type="checkbox"].check-type-2.is-cb-medium + header label::before {
  top: 2px;
  width: 20px;
  height: 20px;
}
input[type="checkbox"]:checked.check-type-1.is-cb-medium + label::before,
input[type="checkbox"]:checked.check-type-2.is-cb-medium + header label::before {
  border-width: 10px;
}
input[type="checkbox"].check-type-1.is-cb-medium + label::after,
input[type="checkbox"].check-type-2.is-cb-medium + header label::after {
  left: 5px;
}

@keyframes check {
  0% {
    visibility: visible;
    width: 0;
    height: 0;
  }
  40% {
    width: 0;
    height: 8px;
  }
  100% {
    visibility: visible;
    width: 12px;
    height: 8px;
  }
}
@keyframes fadein {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeout {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

/*———————————
目的の所在地
———————————*/

/*———————————
被保険者
———————————*/
#owner-same-contractor:checked + header + div,
#insured2 + header + div,
#insured3 + header + div,
#insured4 + header + div,
#insured5 + header + div,
#insured6 + header + div,
#insured7 + header + div,
#insured8 + header + div {
  animation: fadeout 0.5s;
  display: none;
}
#owner-same-contractor + header + div,
#insured2:checked + header + div,
#insured3:checked + header + div,
#insured4:checked + header + div,
#insured5:checked + header + div,
#insured6:checked + header + div,
#insured7:checked + header + div,
#insured8:checked + header + div {
  animation: fadein 0.5s;
  display: block;
}

/*———————————
その他保険
———————————*/
.other-insured-join-info {
  padding: 0.5em 1.2em 0;
}
#other-insured-join + label + div,
#own-other-contract-join + label + div {
  animation: fadeout 0.5s;
  display: none;
}
#other-insured-join:checked + label + div,
#own-other-contract-join:checked + label + div {
  animation: fadein 0.5s;
  display: block;
}

/* wire frame */

.flex-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.flex-item {
  flex: 1;
}

header.pageheader {
  display: flex;
  position: fixed;
  width: 100%;
  height: 70px;
  background: #fff;
  color: #212121;
  justify-content: center;
  align-items: center;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  box-shadow: 1px 1px 4px 0 rgba(0, 0, 0, 0.5);
  z-index: 99;
}

footer.pagefooter {
  display: flex;
  background: #fff;
  color: #ccc;
  width: 100%;
  justify-content: center;
  align-items: center;
  height: 60px;
  box-shadow: 1px -1px 4px 0 rgba(0, 0, 0, 0.2);
}

main {
  padding: 7em 1em 2em 1em;
  height: 100%;
}

main .pagetitle {
  display: flex;
  padding-left: 0.5em;
  font-size: 2em;
  box-shadow: 1px 1px 4px 0 rgba(0, 0, 0, 0.2);
  height: 60px;
  align-items: center;
}

/* Humberger Menu */
div.nav-container {
  position: fixed;
  display: flex;
  height: 100vh;
  width: 100%;
  pointer-events: none;
  z-index: 999;
}
div.nav-container .bg {
  position: absolute;
  top: 70px;
  left: 0;
  width: 100%;
  height: calc(100% - 70px);
  visibility: hidden;
  opacity: 0;
  transition: 0.3s;
  background: #000;
}
div.nav-container:focus-within .bg {
  visibility: visible;
  opacity: 0.6;
}
div.nav-container * {
  visibility: visible;
}
.menu-button {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: 1;
  -webkit-appearance: none;
  border: 0;
  background: transparent;
  border-radius: 0;
  height: 70px;
  width: 30px;
  cursor: pointer;
  pointer-events: auto;
  margin-left: 25px;
  touch-action: manipulation;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.icon-bar {
  display: block;
  width: 100%;
  height: 3px;
  background: #aaa;
  transition: 0.3s;
}
.icon-bar + .icon-bar {
  margin-top: 5px;
}
.menu-item-credit {
  margin: 0;
  padding: 1em;
  background-color: #f44336;
  color: #fff;
  position: absolute;
  width: 100%;
  bottom: 0em;
  border-top: 2px solid #4caf50;
}
div.nav-container:focus-within .menu-button {
  pointer-events: none;
}
div.nav-container:focus-within .icon-bar:nth-of-type(1) {
  transform: translate3d(0, 8px, 0) rotate(45deg);
}
div.nav-container:focus-within .icon-bar:nth-of-type(2) {
  opacity: 0;
}
div.nav-container:focus-within .icon-bar:nth-of-type(3) {
  transform: translate3d(0, -8px, 0) rotate(-45deg);
}
div.nav-content {
  margin-top: 70px;
  padding: 0px;
  width: 90%;
  max-width: 300px;
  position: absolute;
  top: 0;
  left: 0;
  height: calc(100% - 70px);
  background: #fff;
  pointer-events: auto;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  transform: translateX(-100%);
  transition: transform 0.3s;
  will-change: transform;
  contain: paint;
}

div.nav-container:focus-within div.nav-content {
  transform: none;
}

.nav-container a,
.nav-container a:visited,
.nav-container a:focus,
.nav-container a:active,
.nav-container a:link {
  text-decoration: none;
  outline: 0;
}

.nav-container a {
  color: currentColor;
  transition: 0.2s ease-in-out;
}

.nav-logo {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  z-index: 1;
  height: 70px;
  margin-right: 25px;
  margin-left: auto;
}

.nav-logo img {
  height: 3rem;
  width: auto;
}

@media screen and (max-width: 500px) {
  .nav-logo img {
    height: 2rem;
    width: auto;
  }
}

h1,
h2,
h3,
h4 {
  margin: 0;
}

.user-info {
  box-sizing: border-box;
  margin: 1em;
}

div.field p.help {
  min-height: 1.5em;
}

.store-logo {
  max-width: 80px;
}
</style>
